module.exports = __webpack_public_path__ + "img/alipay-icon.c59c7831.png";